 (function () {
    function insertSectionCartDrawer() {
      // Skip if upsell already injected inside cart-drawer-items
      if (document.querySelector('#CartDrawer cart-drawer-items #cart-drawer-upsell')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return
      if (cartDrawerItems.classList.contains('is-empty')) return

      var upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      if (!upsells) return

      // Inject upsell at the end of cart-drawer-items (scrolls with cart items)
      cartDrawerItems.insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!cartDrawerItems.querySelector('.cart-drawer-upsell-list li')) {
        var upsellEl = cartDrawerItems.querySelector('#cart-drawer-upsell')
        if (upsellEl) upsellEl.remove()
      }
    }
    insertSectionCartDrawer()

    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return

      let timer

      const observer = new MutationObserver((mutations) => {
        // Immediately re-inject upsell so it's always present
        insertSectionCartDrawer()

        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          // Then fetch updated upsell (excludes products now in cart)
          try {
            const response = await fetch(window.location.href)
            const text = await response.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')
            const newUpsell = newDocument.querySelector('#cart-drawer-upsell-wrapper')
            const oldUpsell = document.querySelector('#cart-drawer-upsell-wrapper')

            if (newUpsell && oldUpsell) {
              observer.disconnect()
              oldUpsell.replaceWith(newUpsell)
              // Remove existing upsell from cart-drawer-items and re-inject fresh one
              var existing = document.querySelector('#CartDrawer cart-drawer-items #cart-drawer-upsell')
              if (existing) existing.remove()
              var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
              if (cartDrawerItems && !cartDrawerItems.classList.contains('is-empty')) {
                cartDrawerItems.insertAdjacentHTML('beforeend', newUpsell.innerHTML)
                if (!cartDrawerItems.querySelector('.cart-drawer-upsell-list li')) {
                  var upsellEl = cartDrawerItems.querySelector('#cart-drawer-upsell')
                  if (upsellEl) upsellEl.remove()
                }
              }
              observer.observe(element, { attributes: true, childList: true, subtree: true })
            }
          } catch (e) {
            // Silently fail - upsell from initial injection is still shown
          }
        }, 500)
      })

      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer

      const observer = new MutationObserver((mutations) => {
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    listenCartPage()
  })();